import { PencilSimpleIcon, TrashIcon } from '@phosphor-icons/react';

import { Button, MarkdownText, Modal, Stack } from '../../../components';
import { Style } from '../../../constants';

type Props = {
  instructions: string;
  canManage: boolean;
  onClose: () => void;
  onEdit: () => void;
  onDelete: () => void;
};

export default function InstructionsModal({
  instructions,
  canManage,
  onClose,
  onEdit,
  onDelete,
}: Props) {
  return (
    <Modal title="Instructions" onClose={onClose} fullScreenOnMobile>
      {/* instructions is markdown (like Release.changelog) — render as-is,
          including any embedded image such as a 2FA QR code. */}
      <Stack padH={1.5} padV={1.5} gap={1.5}>
        <MarkdownText body={instructions} />
      </Stack>
      {canManage && (
        <Stack padH padV style={[Style.row, Style.justifyEnd]} gap={0.5}>
          <Button
            label="Delete instructions"
            variant="text"
            colorScheme="accent"
            iconLeft={(p) => <TrashIcon {...p} />}
            onClick={onDelete}
          />
          <Button
            label="Edit"
            variant="text"
            colorScheme="black"
            iconLeft={(p) => <PencilSimpleIcon {...p} />}
            onClick={onEdit}
          />
        </Stack>
      )}
    </Modal>
  );
}
